import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import CustomDropdown from "../../CustomControls/dropdownnnn";
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../Global/Endpoints';
import ErrorModal from "../Security/ErrorModal";
import { renderAsync } from 'docx-preview';
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { Trans } from "react-i18next";
import mammoth from 'mammoth'; 
import * as UTIF from "utif";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const NO_CURRENCIES_MESSAGE = "No currency available. Please try again later.";
const formatCurrencyOption = (currencyOption) =>
    [currencyOption.ID, currencyOption.Text]
        .map((value) => value === undefined || value === null ? "" : String(value).trim())
        .filter(Boolean)
        .join(" - ");

const WINPayReaimbursement = () =>
{
    const userInfo = useSelector((state) => state.userData);
    const token = localStorage.getItem('AccessToken');
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [serviceTypes, setServiceTypes] = useState([]);
    const [selectedServiceType, setSelectedServiceType] = useState("");
    const [isServiceTypeListOpen, setIsServiceTypeListOpen] = useState(true);
    const [currentService, setCurrentService] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [documentType, setDocumentType] = useState("Fertility Cycle Reimbursement Receipts");
    const [physicianName, setPhysicianName] = useState("");
    const [physicianTel, setPhysicianTel] = useState("");
    const [formErrors, setFormErrors] = useState({});
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [isAddRow, setIsAddRow] = useState(false);
    const [tableRows, setTableRows] = useState([{ date: "", description: "", currency: "", amount: "",isEditable: true, isCurrencyDisabled: false, }]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isFileError, setIsFileError] = useState(false);
    const fileInputRef = useRef(null);
    const [fileToDeleteIndex, setFileToDeleteIndex] = useState(null);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currencies, setCurrencies] = useState([]);
    const [isCurrenciesLoading, setIsCurrenciesLoading] = useState(false);
    const [reproductiveType, setReproductiveType] = useState("");
    const [providerOptions, setProviderOptions] = useState([]);
    const [filteredProviderOptions, setFilteredProviderOptions] = useState([]);
    const [showProviderDropdown, setShowProviderDropdown] = useState(false);
    const [hasShownGroupValidation, setHasShownGroupValidation] = useState(false);
    const [groupOptions, setGroupOptions] = useState([]);
    const [filteredGroupOptions, setFilteredGroupOptions] = useState([]);
    const [showGroupDropdown, setShowGroupDropdown] = useState(false);
    const [groupName, setGroupName] = useState("");
    const [showValidationModal, setShowValidationModal] = useState(false);
    const isAgency = ["Surrogacy", "Adoption", "Donor Egg", "Donor Sperm"]
    .some(term => selectedServiceType.toLowerCase().includes(term.toLowerCase()));
    const isProvider = ["Elective Cryopreservation"]
    .some(term => selectedServiceType.toLowerCase().includes(term.toLowerCase()));
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const companyName = localStorage.getItem("employer");
    const [isDocsUploading, setIsDocUploading] = useState(false);
    const currencyOptions = useMemo(
        () => currencies.map(formatCurrencyOption),
        [currencies]
    );
    const highmarkCurrency = useMemo(
        () => currencies.find((item) =>
            item.Text === "United States Dollar" ||
            String(item.ID).toUpperCase() === "USD" ||
            String(item.Tag || "").toUpperCase() === "USD"
        ),
        [currencies]
    );

    const getPageCount = (file) => {
        return new Promise(async (resolve, reject) => {
            const bytes = await file.arrayBuffer()
            
            const loadingTask = pdfjsLib.getDocument({
                data: bytes,
                disableWorker: true});
             try {
                const pdf = await loadingTask.promise;
                const pages = pdf.numPages;
                resolve(pages);
             } catch (error) {
                reject(error);
            }
        });
    };

    useEffect(() => {
        // Fetch data from the API
        const fetchServiceTypes = async () => {
            setLoading(true);
            try {
                const params = {
                            MemberID: userInfo.userData.MemberID,
                            Contract: userInfo.userData.ContractIdentified,
                            ContractCode: 0,
                            URL: null,
                            Room: null,
                            Name: null,
                            EmailID: userInfo.userData.EmailID,
                            DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
                        };
                const response = await axios.post(
                    Endpoints.LoadServiceType,
                    
                        { _Params: JSON.stringify(params) ,
                         _DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
                    },
                    {
                        headers: {
                          "Content-Type": "application/x-www-form-urlencoded",
                          "Accept": "*/*",
                          Authorization: `Bearer ${token}`,
                        },
                      }
                );
                // Check if the response has valid data
                if (response.data && Array.isArray(response.data)) {
                    setServiceTypes(response.data);
                } else {
                    console.log("Unexpected response format:", response.data);
                    console.log("No valid service types found.");
                }
            } catch (error) {
                console.error("Error fetching service types:", error);
            } finally { 
                setLoading(false); 
            }
        };

        fetchServiceTypes();
    }, []);

    useEffect(() => {
        const fetchCurrencies = async () => {
            const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
            setIsCurrenciesLoading(true);

            try {
                const response = await axios.post(
                    Endpoints.LoadCurrencies,
                    new URLSearchParams({
                        _Params: JSON.stringify({
                            EmailID: userInfo.userData.EmailID,
                            DeviceType: deviceType,
                        }),
                    }),
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const currencyData = Array.isArray(response.data) ? response.data : [];
                setCurrencies(
                    currencyData.filter(
                        (item) => item && formatCurrencyOption(item)
                    )
                );
            } catch (error) {
                console.error("Error fetching currencies:", error);
                setCurrencies([]);
            } finally {
                setIsCurrenciesLoading(false);
            }
        };

        fetchCurrencies();
    }, [isHighmarkPortal, token, userInfo.userData.EmailID]);

    const fetchGroupDetails = async (name = "") => {
        const params = {
            EmailID: userInfo.userData.EmailID,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            GroupName: name || "",
            Contract: userInfo.userData.ContractIdentified,
            Country: "",
        };

        try {
            const response = await axios.post(
                Endpoints.GetGroupDetails,
                { _Params: JSON.stringify(params) },
                {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Connection": "close",
                    "Accept": "*/*",
                    Authorization: `Bearer ${token}`,
                },
                }
            );

            const responseData = Array.isArray(response.data) ? response.data : [];

            if (responseData) {
                setGroupOptions(responseData);
                setFilteredGroupOptions(
                    responseData.filter(opt =>
                    opt.GroupName.toLowerCase().includes(name.toLowerCase()))
                );
            } else {
                setGroupOptions([]);
                setFilteredGroupOptions([]);
            }
        } catch (error) {
            setGroupOptions([]);
            setFilteredGroupOptions([]);
        }
    };

    const handleServiceTypeChange = (option) => {
        setGroupName("");
        setSelectedServiceType(option);
        setIsServiceTypeListOpen(false);
        const service = serviceTypes.find(opt => opt.Text === option || opt.Tag === option);
        setCurrentService(service);
        setFormErrors((prevErrors) => ({ ...prevErrors, serviceType: "" }));
        const normalized = option.toLowerCase();

        if (normalized.includes("cryopreservation")) {
            setReproductiveType("Egg");
        } else if (["Donor Egg", "Donor Sperm"]
            .some(term => normalized.includes(term.toLowerCase()))) {
            setReproductiveType("Frozen");
        } else {
            setReproductiveType("");
        }
        setPhysicianName("");
        if (isFormSubmitted) {
            if (!physicianName) formErrors.physicianName = isAgency ? t("Agencynamevalid") : isProvider ? t("Providernamevalid") : t("Physiciannamevalid");
            if (!physicianTel) formErrors.physicianTel = isAgency ? t("Agencytelvalid") : isProvider ? t("Providertelvalid") : t("Physiciantelvalid");
        }
        // Call ReimbursementProviderDetails on service type change if isAgency or isProvider
        ReimbursementProviderDetails("", option);
    };

    // Update ReimbursementProviderDetails to handle autocomplete
    const ReimbursementProviderDetails = async (name = "", serviceType = "") => {
        const params = {
            EmailID: userInfo.userData.EmailID,
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            GroupName: name ? name : "",
            ServiceType: serviceType || ""
        };
        try {
            const response = await axios.post(
                Endpoints.ReimbursementProviderDetails,
                {
                    _Params: JSON.stringify(params),
                    _DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
                },
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "*/*",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data && response.data.ProviderDetailsList) {
                setProviderOptions(response.data.ProviderDetailsList);
                // Filter options to match input
                setFilteredProviderOptions(
                    response.data.ProviderDetailsList.filter(opt =>
                        opt.GroupName.toLowerCase().includes((name || '').toLowerCase())
                    )
                );
            } else {
                setProviderOptions([]);
                setFilteredProviderOptions([]);
            }

        } catch (error) {
            setProviderOptions([]);
            setFilteredProviderOptions([]);
            console.error("No data received from the reimbursement provider.", error);
        }
    };

    const fetchProviders = async (groupId) => {
        try {
        const params = {
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            GroupID: groupId,
            EmailID: userInfo.userData.EmailID,
            Contract: userInfo.userData.ContractIdentified,
        };
        const response = await axios.post(
            Endpoints.GetProviderDetails,
            { _Params: JSON.stringify(params) },
            {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Connection": "close",
                "Accept": "*/*",
                Authorization: `Bearer ${token}`,
            },
            }
        );
        setProviderOptions(response.data);
        } catch (error) {
        console.error("Error fetching providers:", error);
        }
    };

    const handleFileSelection = (event) => {
        const validExtensions = ["pdf", "tiff", "jpeg", "jpg", "bmp", "png"];
        const files = Array.from(event.target.files);
        let anyInvalidType = false;
        let oversizedFileName = "";
        let duplicateFound = false;

        // Check for duplicates with already selected files
        for (const file of files) {
            const isDuplicate = selectedFiles.some(
                f => f.name === file.name && f.size === file.size
            );
            if (isDuplicate) {
                duplicateFound = true;
                break;
            }
        }

        // Check for duplicates within the new files themselves
        const fileSignatures = new Set();
        for (const file of files) {
            const signature = `${file.name}_${file.size}`;
            if (fileSignatures.has(signature)) {
                duplicateFound = true;
                break;
            }
            fileSignatures.add(signature);
        }

        if (duplicateFound) {
            return toast.error("Duplicate file(s) detected. Please select unique files only.");
        }

        if((files.length + selectedFiles.length)>4) return toast.error("Maximum 4 files are allowed");
        const validFiles = files.filter(file => {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                anyInvalidType = true;
                return false;
            }
            if (file.size > 5 * 1024 * 1024) {
                oversizedFileName = file.name;
                return false;
            }
            return true;
        });
        if (anyInvalidType) {
            setModalMessage("Invalid file type. Only PDF, TIFF, JPEG, BMP, or PNG allowed.");
            setIsFileError(true);
            setShowModal(true);
            return;
        } else if (oversizedFileName) {
            setModalMessage(`The ${oversizedFileName} is too large (over 5MB). Please upload a smaller file.`);
            setIsFileError(true);
            setShowModal(true);
            return;
        }
        setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
        setFormErrors((prevErrors) => ({ ...prevErrors, files: "" }));

        // Clear the file input value to allow re-uploading the same file
        if (event.target) {
            event.target.value = null;
        }
        
    };

    const handleSubmit = async () => {
        const errors = {};
        if (!selectedServiceType) errors.serviceType = t("servicetypevalid");
        if (!selectedFiles.length) errors.files = t("filevalid");
        if (!physicianName.trim()) errors.physicianName = isAgency
            ? t("Agencynamevalid") : isProvider ? t("Providernamevalid") : t("Physiciannamevalid");
        if (!physicianTel) errors.physicianTel = isAgency
            ? t("Agencytelvalid") : isProvider ? t("Providertelvalid") : t("Physiciantelvalid");
        if (!isAgency && !groupName) errors.groupName = t("Groupnamevalid");
        if (!tableRows.length) errors.table = "At least one row is required.";
        if (!checkboxChecked) errors.checkbox = "You must agree to the terms.";

        // Validate each row's description for non-empty and not just spaces
        tableRows.forEach((row, idx) => {
            if (!row.description || row.description.trim() === "") {
            errors.table = "Description cannot be empty or just spaces.";
            }
        });

        const validRows = tableRows.filter(
        (row) =>
          row.date &&
          row.description.trim() !== "" &&
          row.currency &&
          row.amount
        );
    
        if (validRows.length === 0) {
            errors.table = "At least one row is required.";
        }
    
        setFormErrors(errors);
        if (!checkboxChecked) errors.checkbox = "You must agree to the terms.";
      
        setFormErrors(errors);
      

        setIsFormSubmitted(true);
        if (Object.keys(errors).length > 0) {
            return;
        }
    
        try {
            let fileID = 1; // Initialize FileID to start from 1
            const payloads = []; // Array to hold all file payloads
    
            for (const file of selectedFiles) {
                let noOfPages = 1;
    
                // Determine the number of pages based on file type
                try {
                    const fileType = file.type;
                    
                    if (fileType === "application/pdf") {
                        noOfPages = await getPageCount(file);
                    } else if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                        const arrayBuffer = await file.arrayBuffer();
                        const content = await mammoth.extractRawText({ arrayBuffer });
                        const wordCount = content.value.split(/\s+/).length;
                        noOfPages = Math.ceil(wordCount / 500);
                    } else if (fileType === "text/plain") {
                        const textContent = await file.text();
                        const lineCount = textContent.split(/\r?\n/).length;
                        noOfPages = Math.ceil(lineCount / 50);
                    } else if (fileType === "image/tiff") {
                        const buffer = await file.arrayBuffer();
                        const pages = UTIF.decode(buffer); // Decode TIFF file
                        noOfPages = pages.length; // Number of pages in the TIFF file
                    } else if (
                        fileType === "image/jpeg" ||
                        fileType === "image/png" ||
                        fileType === "image/bmp"
                    ) {
                        noOfPages = 1 // Single-page image
                    }
                } catch (err) {
                    console.warn(`Failed to get page count for ${file.name}`, err);
                }
    
                const fileToBase64 = (file) =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(",")[1]);
                        reader.onerror = (error) => reject(error);
                        reader.readAsDataURL(file);
                    });
    
                const base64Data = await fileToBase64(file);
    
                // Create payload for each file
                const filePayload = {
                    FileID: fileID.toString(), // Use the incrementing FileID
                    FilePath: "",
                    FileName: file.name,
                    NoOFPages: noOfPages.toString(),
                    DocTypeDesc: "",
                    inputBytes: base64Data,
                    fileSize: file.size.toString(),
                    memberId: userInfo.userData.MemberID,
                    contract: userInfo.userData.ContractIdentified,
                    contractCode: "",
                    docTypeDescription: documentType,
                    DeviceType:isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
                    EmailID:userInfo.userData.EmailID
                };
    
                payloads.push(filePayload);
                fileID++; // Increment FileID for the next file
            }
            const totalFiles = payloads.length;
            setLoading(true);
            setIsDocUploading(true);
            // Send all files in a single request
            const response = await axios.post(
                Endpoints.UploadDocument,
                JSON.stringify(payloads),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Prepare SendToWin payload for all files
            const sendToWinPayload = {
                _Params: JSON.stringify({
                    MemberID: userInfo.userData.MemberID,
                    Contract: userInfo.userData.ContractIdentified,
                    DocumentTypes: "",
                    TotalFiles: totalFiles,
                    DoctypeDesc: documentType,
                    Documents: response.data.map((file, index) => ({
                        NoOFPages: payloads[index].NoOFPages,
                        FilePath: file.FilePath,
                        FileID: payloads[index].FileID,
                        FileName: payloads[index].FileName,
                        DocTypeDesc: "",
                    })),
                    ReimbursementDetails: tableRows.map((row) => ({
                        DateIncurred: row.date.toLocaleDateString("en-US"),
                        ServiceName: row.description,
                        Currency: row.currency,
                        Amount: parseFloat(parseFloat(row.amount).toFixed(2)),
                    })),
                    TotalAmount:  parseFloat(
                        tableRows.reduce((sum, row) => sum + parseFloat(row.amount|| 0),  0).toFixed(2)
                    ),
                    PhysicianName: physicianName,
                    PhysicianTelNo: physicianTel,
                    GroupName: groupName,
                    PhysicianTaxNo: null,
                    ReimbursementType: "I would like to be reimbursed for an eligible service",
                    ServiceType: currentService.AuthNo == 0 || !currentService.Tag ? currentService.Text : currentService.Tag,
                    ReproductiveType: reproductiveType || "",
                    AuthNo: currentService.Authno === 0 ? "" : currentService.Authno,
                    DisplayContract: userInfo.userData.Employer || "",
                    EmailID: userInfo.userData.EmailID || null, 
                    UserName: "MAPP", 
                    ProviderID: null, 
                    GroupID: "", 
                    Speciality: null, 
                    Activity: null, 
                    DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal"
                }),
            };
            // Call SendToWin API
            const res = await axios.post(Endpoints.SendToWin, sendToWinPayload, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (res.data?.Result === undefined || Number(res.data?.Result) === 2) {
                setIsFileError(false);
                setIsAddRow(false);
                setSelectedFiles([]);
                setDocumentType("");
                setModalMessage(res.data?.ResultText || "Documents sent to WIN successfully.");
                setShowModal(true);
            } else {
                setModalMessage(res.data?.ResultText || "An unexpected error occurred.");
                setShowModal(true);
            }
          // call ReimbursementProviderDetails  api
          if(isAgency || isProvider) {
            ReimbursementProviderDetails(physicianName, selectedServiceType);
          }
            
        } catch (error) {
            console.error("Error during document submission:", error);
            console.log("An error occurred while processing the documents.");
        }
        finally {        
             setLoading(false); 
             setIsDocUploading(false);   
        }
    };

    const handleViewFile = async (file) => {
        const fileType = file.type;

        if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            const fileArrayBuffer = await file.arrayBuffer();
            const newWindow = window.open("", "_blank");

            if (newWindow) {
                newWindow.document.write(`
                    <html>
                        <head>
                            <title>Document Preview</title>
                            <style>body { font-family: Arial; margin: 20px; }</style>
                        </head>
                        <body>
                            <div id="docx-preview"></div>
                        </body>
                    </html>
                `);
                newWindow.document.close();

                renderAsync(fileArrayBuffer, newWindow.document.getElementById("docx-preview"));
            }

        } else if (fileType === "image/tiff" || fileType === "image/tif") {
            const buffer = await file.arrayBuffer();
            const ifds = UTIF.decode(buffer);

            const first = ifds[0];
            UTIF.decodeImage(buffer, first);

            const rgba = UTIF.toRGBA8(first);

            const canvas = document.createElement("canvas");
            canvas.width = first.width;
            canvas.height = first.height;

            const ctx = canvas.getContext("2d");
            const imageData = ctx.createImageData(first.width, first.height);
            imageData.data.set(rgba);
            ctx.putImageData(imageData, 0, 0);

            const newWindow = window.open("", "_blank");
            newWindow.document.body.appendChild(canvas);
        } else {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
        }
    };
    const handleFileDelete = (index) => {
        setModalMessage("Are you sure you want to delete this file?");
        setFileToDeleteIndex(index); // Set the file index for deletion
        setShowDeleteModal(true);
    };

     // Add a new row
     const handleAddRow = () => {
        const lastRow = tableRows[tableRows.length - 1];
        if (!lastRow.date || !lastRow.description || !lastRow.currency || !lastRow.amount) {
          setModalMessage("Please fill all fields in the current row before adding a new row.");
          setIsAddRow(true); // Reset the flag
          setShowModal(true);
          return;
        }

       // Mark the last row as non-editable
    const updatedRows = tableRows.map((row, index) =>
        index === tableRows.length - 1 ? { ...row, isEditable: false, isCurrencyDisabled: true } : row
      );
    
      // Add a new row with isEditable set to true
      setTableRows([
        ...updatedRows,
        { date: "", description: "", currency: isHighmarkPortal && highmarkCurrency ? formatCurrencyOption(highmarkCurrency) : lastRow.currency, amount: "", isEditable: true, isCurrencyDisabled: true },
      ]);
      };

      const handleDeleteRow = (index) => {
        if (tableRows.length === 1) {
          setTableRows([{ date: "", description: "", currency: isHighmarkPortal && highmarkCurrency ? formatCurrencyOption(highmarkCurrency) : "", amount: "",isEditable: true,isCurrencyDisabled: isHighmarkPortal && Boolean(highmarkCurrency) }]);
    
          setTotalAmount(0);
          
        } else {
            const rowToDelete = tableRows[index];
  
            // Check if the row has no data
            const isRowEmpty =
              !rowToDelete.date &&
              !rowToDelete.description &&
              !rowToDelete.currency &&
              !rowToDelete.amount;
        
            if (!isRowEmpty) {
              // Remove the row if it contains data
              const updatedRows = tableRows.filter((_, i) => i !== index);
               // If only one row remains, make it editable
            if (updatedRows.length === 1) {
                updatedRows[0].isEditable = true;
                updatedRows[0].isCurrencyDisabled = isHighmarkPortal && Boolean(highmarkCurrency);
                if (isHighmarkPortal) {
                    updatedRows[0].currency = highmarkCurrency ? formatCurrencyOption(highmarkCurrency) : "";
                }
            }
              setTableRows(updatedRows);
              calculateTotalAmount(updatedRows);
            } else {
              // If row is empty, mark it non-editable
              const updatedRows = tableRows.map((row, i) =>
                i === index ? { ...row, isEditable: false } : row
              );
              setTableRows(updatedRows);
            }
          }
      };
    
  // Handle input change for specific field and row
  const handleInputChange = (index, field, value) => {
    const updatedRows = tableRows.map((row, i) =>{
        if (i === index && row.isEditable) {

            if (field === "currency" && row.isCurrencyDisabled) return row;

            const updatedValue = field === "amount" ? sanitizeAmountInput(value) : value;

            return { ...row, [field]: updatedValue };
          }
          return row;
        });
     // Ensure rows are updated and total amount is recalculated
     setTableRows(updatedRows);
     calculateTotalAmount(updatedRows);
    // Dynamically validate table rows
    const allRowsValid = updatedRows.every(
        (row) =>
        row.date &&
        row.description &&
        row.currency &&
        row.amount
    );

    setFormErrors((prevErrors) => ({
        ...prevErrors,
        table: allRowsValid ? "" : prevErrors.table, // Clear error if all rows are valid
    }));
  };

  const handleKeyDown = (e) => {
    // Prevent entering 'e', '-', and '+' characters
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };
  
// Utility for formatting numbers in US format
const formatAmountForDisplay = (value) => {
    if (!value || isNaN(value)) return "";
  const numericValue = parseFloat(value);
    return numericValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Utility method for sanitizing the input
const sanitizeAmountInput = (value) => {
    // Allow only numbers and one decimal point
    let sanitizedValue = value.replace(/[^0-9.]/g, "");
  
    // Prevent multiple decimal points
    if ((sanitizedValue.match(/\./g) || []).length > 1) {
      return sanitizedValue.substring(0, sanitizedValue.lastIndexOf("."));
    }
    // Prevent input from starting with a dot
    if (sanitizedValue.startsWith(".")) {
        sanitizedValue = "0."; // Automatically prefix with "0"
      }
    // Restrict to two decimal places
    if (sanitizedValue.includes(".")) {
      const [integerPart, decimalPart] = sanitizedValue.split(".");
      sanitizedValue = `${integerPart}.${decimalPart.slice(0, 2)}`;
    }
  
    // Prevent leading zeros unless it's "0."
    if (sanitizedValue.startsWith("0") && !sanitizedValue.startsWith("0.") && sanitizedValue.startsWith(".")) {
      sanitizedValue = sanitizedValue.replace(/^0+/, "");
    }

    return sanitizedValue;
  };
  useEffect(() => {
    if (isHighmarkPortal && !isCurrenciesLoading) {
      setTableRows((rows) =>
        rows.map((row) => ({
          ...row,
          currency: highmarkCurrency ? formatCurrencyOption(highmarkCurrency) : "",
          isCurrencyDisabled: Boolean(highmarkCurrency),
        }))
      );
    }
  }, [highmarkCurrency, isCurrenciesLoading, isHighmarkPortal]);

  const confirmDeleteRow = () => {
    if (fileToDeleteIndex !== null) {
        setSelectedFiles((prevFiles) =>
            prevFiles.filter((_, i) => i !== fileToDeleteIndex)
        );
        setFileToDeleteIndex(null); // Reset the file index after deletion
    }
    setShowDeleteModal(false); // Close the modal
  };

  // Calculate total amount
  const calculateTotalAmount = (rows) => {
    const total = rows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
    setTotalAmount(total);
  };

  const handleModalClose = () => {
    setShowModal(false);
    if(isFileError || isAddRow)
    {
        return;
    }
        navigate("/pay-landingpage");
    
     
  };
  const handleBackClick = () => {
    navigate("/pay-landingpage");
};
const onBrowse = () => {
    const input = document.getElementById('fileInput');
    if (input) {
        input.value = null; // Always reset so change event fires even for same file
        input.click();
    }
};

const selectedServiceOption = serviceTypes.find(
    (option) => option.Text === selectedServiceType
);

if (loading) {
    return (
        <div className="loading-container">
            <div className="loading mb-2"></div>
                <h2 className="loading-text">
                {!isDocsUploading ? (
                    t("loading")
                ) : (
                    <>
                    Your documents are being securely uploaded.
                    <br />
                    Please wait for a moment.
                    </>
                )}
                </h2>            
            </div>
        );
}

return(
    <>
 <ToastContainer />
    {isHighmarkPortal ? 
        <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>       
            <h2 className="page-heading">
                {isHighmarkPortal ? "Fertility and Family Building Pay Reimbursement" : t('winPayReimbursement')}
            </h2>
            </div>:
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={handleBackClick}>
                    <span>
                    <i className="bi bi-chevron-left"></i>    
                    {t('Back')}        
                    </span>
                </button>       
                <h2 className="page-heading">
                    {isHighmarkPortal ? "Fertility and Family Building Pay Reimbursement" : t('winPayReimbursement')}
                </h2>
            </div>
          }

        <div className="col-md-12 mb-2 mb-md-5">
            <b>{t('reimbursementRequest')}</b>
        </div>


        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-12">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                    {t('servicetype')}
                    </label>
                </div>
                      
                <div class="col-12">
                    <div className="supporting-service-options" role="radiogroup" aria-label={t("servicetype")}>
                        {loading ? (
                            <div className="supporting-service-loading" aria-live="polite" aria-label={t("loading")}>
                                <div className="supporting-service-spinner" />
                            </div>
                        ) : selectedServiceOption && !isServiceTypeListOpen ? (
                            <button
                                type="button"
                                className="supporting-service-selected-summary"
                                onClick={() => setIsServiceTypeListOpen(true)}
                                aria-expanded={isServiceTypeListOpen}
                            >
                                <span className="supporting-service-selected-summary-header">
                                    <span className="supporting-service-option-title">{selectedServiceOption.Text}</span>
                                    <i className="bi bi-chevron-down supporting-service-selected-summary-icon" aria-hidden="true"></i>
                                </span>
                                {selectedServiceOption.DateRange && (
                                    <span className="supporting-service-selected-summary-date">{selectedServiceOption.DateRange}</span>
                                )}
                            </button>
                        ) : (
                            serviceTypes.map((option) => (
                                <button
                                    key={option.Value ?? option.Tag ?? option.Text}
                                    type="button"
                                    className={`supporting-service-option supporting-service-option--single-line${selectedServiceType === option.Text ? " selected" : ""}`}
                                    onClick={() => handleServiceTypeChange(option.Text)}
                                    aria-pressed={selectedServiceType === option.Text}
                                >
                                    <span className="supporting-service-option-title">{option.Text}</span>
                                    {option.DateRange && (
                                        <span className="supporting-service-option-date">{option.DateRange}</span>
                                    )}
                                </button>
                            ))
                        )}
                    </div>

                    {formErrors.serviceType && <div className="form-field-error-message">{formErrors.serviceType}</div>}
                </div>
            </div>
        </div>

        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-auto ">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                     {t('uploadFilesLabel')} 
                    </label>
                </div> 

                <div class="col-auto">

                    
                <div class="custom-file-upload ms-auto">
                    <input
                        type="file"
                        multiple
                        id="fileInput"
                        class="file-input"
                        onChange={handleFileSelection}
                        ref={fileInputRef}
                        accept=".pdf, .tiff, .jpeg, .jpg, .bmp, .png"
                    />
                    <div class="input-display">
                        <input type="text" class="file-text" placeholder={t("choosefileplaceholder")} readonly />
                        <button type="button" class="custom-button"  onClick={onBrowse}>{t("browse")}</button>
                    </div>
                </div>
       

                <div className="note-gray-boldd-14">
                    {t('validationsmsg')}
                </div>
                <div className="form-field-error-message">
                    {isAgency && <div>*Reimbursement Form required for claim review text</div>}
                    {formErrors.files && <div className="form-field-error-message">{formErrors.files}</div>}
                </div>
                </div>
                     </div>
        </div>
        <div>
            {["Donor Egg", "Donor Sperm"].some(type =>
                    selectedServiceType.toLowerCase().includes(type.toLowerCase())
                ) && (
                ["Frozen", "Fresh"].map((type) => (
                    <span key={type}>
                        <input
                            type="radio"
                            id={`${type.toLowerCase()}Option`}
                            name="reproductiveTypeOptions"
                            value={type}
                            checked={reproductiveType === type}
                            onChange={() => setReproductiveType(type)}
                        />
                        <label style={{ marginLeft: "6px",transform: "translateY(-4px)"}} htmlFor={`${type.toLowerCase()}Option`}>{type}</label>
                    </span>
                ))
            )}
            {selectedServiceType.toLowerCase().includes("cryopreservation") && (
                ["Egg", "Sperm", "Embryo"].map((type) => (
                    <span key={type}>
                        <input
                            type="radio"
                            id={`${type.toLowerCase()}Option`}
                            name="reproductiveTypeOptions"
                            value={type}
                            checked={reproductiveType === type}
                            onChange={() => setReproductiveType(type)}
                        />
                        <label style={{ marginLeft: "6px",transform: "translateY(-4px)"}}htmlFor={`${type.toLowerCase()}Option`}>{type}</label>
                    </span>
                ))
            )}
        </div>
        <div className="mt-2 md-5">
        <div className="form-field-error-message">{t('msg')}</div>
        </div>
        <div className="mt-2 winpay-table-wrapper">
            <table className="table">
                <thead className="winpay-table-header">
                    <tr className="winpay-table-header">
                        <th width="80%">{t("filenamelable")}</th>
                        <th width="140" className="text-center">{t("btnview")}</th>
                        <th width="140" className="text-center">{t("btndelete")}</th>
                    </tr>
                </thead>
                <tbody>
                {selectedFiles.map((file, index) => (
                            <tr className="winpay-table-row" key={index}>
                                <td>{file.name}</td>
                                <td className="text-center">
                                    <button
                                        className="winpay-table-view-icon mx-auto"
                                        onClick={() => handleViewFile(file)}
                                    >
                                    </button>
                                </td>
                                <td className="text-center">
                                    <button
                                        className="winpay-table-trash-icon mx-auto"
                                        onClick={() => handleFileDelete(index)}
                                    >
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {selectedFiles.length === 0 && (
                            <tr>
                                <td colSpan="3" className="text-center">
                                {t('noFilesUploaded')}
                                </td>
                            </tr>
                        )}
                </tbody>
            </table>
        </div>

        {!isAgency && (
        <>
            <div className="col-md-6">
                <div className="mb-3 row flex-sm-row flex-column">
                <div className="col-md-4 d-flex align-items-center">
                    <label className="form-label win-form-label mt-2 mb-0">
                        Group/Hospital Name<span className="required-field ms-1">*</span>
                    </label>
                </div>

                <div className="col-md-8">
                    <div>
                    <input
                        type="text"
                        className="form-control win-form-control mobile-view"
                        value={groupName}
                        autoComplete="off"
                        maxLength="100"
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            setGroupName(inputValue);
                            setFormErrors((prev) => ({
                                ...prev,
                                groupName: "",
                            }));

                            if (groupOptions.length > 0) {
                                const filtered = groupOptions.filter((opt) =>
                                opt.GroupName.toLowerCase().includes(inputValue.toLowerCase())
                                );

                                setFilteredGroupOptions(filtered);
                                setShowGroupDropdown(true);
                            }
                        }}
                        onBlur={() => {
                            setTimeout(() => setShowGroupDropdown(false), 150);
                        }}
                        onFocus={() => {
                            fetchGroupDetails("");
                            setShowGroupDropdown(true);
                        }}
                    />
                    <div className="form-field-error-message">
                        {formErrors.groupName && <div className="form-field-error-message">{formErrors.groupName}</div>}
                    </div>

                    {showGroupDropdown && filteredGroupOptions.length > 0 && (
                        <ul className="dropdown-list">
                        {filteredGroupOptions.map((opt, idx) => (
                            <li
                            key={idx}
                            onMouseDown={() => {
                                setGroupName(opt.GroupName);
                                setShowGroupDropdown(false);
                                fetchProviders(opt.GroupID);
                            }}
                            >
                            {opt.GroupName}
                            </li>
                        ))}
                        </ul>
                    )}
                    </div>
                </div>
                </div>
            </div>
        </>
        )}

        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-md-4">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                    {isAgency ? t("Agencyname"): isProvider ? t("providername") : t("Physicianname")}
                    </label>
                </div>

                <div class="col-md-8">
                    {isAgency || isProvider ? (
                        <div>
                            <input
                                type="text"
                                className="form-control win-form-control mobile-view"
                                id="providerNameDropdown"
                                value={physicianName}
                                autoComplete="off"
                                maxLength="100"
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    setPhysicianName(inputValue);
                                    setFormErrors((prevErrors) => ({ ...prevErrors, physicianName: "" }));
                                    if (isAgency || isProvider) {
                                        if (providerOptions.length > 0) {
                                            setFilteredProviderOptions(
                                                providerOptions.filter(opt =>
                                                    opt.GroupName.toLowerCase().includes((inputValue || '').toLowerCase())
                                                )
                                            );
                                            setShowProviderDropdown(true);
                                        } else {
                                        }
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowProviderDropdown(false), 150); // Delay to allow click
                                }}
                                onFocus={() => {
                                    if (filteredProviderOptions.length > 0) setShowProviderDropdown(true);
                                }}
                            />
                            {showProviderDropdown && filteredProviderOptions.length > 0 && (
                                <ul className="dropdown-list">
                                    {filteredProviderOptions.map((opt, idx) => (
                                        <li
                                            key={idx}
                                            onMouseDown={() => {
                                                setPhysicianName(opt.GroupName);
                                                setShowProviderDropdown(false);
                                                setProviderOptions([]);
                                                setFilteredProviderOptions([]);
                                            }}
                                        >
                                            {opt.GroupName} 
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : (
                    <div>
                        <input
                            type="text"
                            className="form-control win-form-control mobile-view"
                            value={physicianName}
                            autoComplete="off"
                            maxLength="100"
                            onChange={(e) => {
                                if (!groupName) {
                                    setModalMessage("Please select a group before selecting a physician.");
                                    setShowValidationModal(true);
                                    return;
                                }

                                const inputValue = e.target.value;
                                setPhysicianName(inputValue);

                                setFormErrors((prev) => ({
                                    ...prev,
                                    physicianName: "",
                                }));

                                if (providerOptions.length > 0) {
                                    const filtered = providerOptions.filter((opt) =>
                                        opt.ProName.toLowerCase().includes(inputValue.toLowerCase())
                                    );

                                    setFilteredProviderOptions(filtered);
                                    setShowProviderDropdown(true);        
                                }
                            }}
                            onBlur={() => {
                                setTimeout(() => setShowProviderDropdown(false), 150);
                            }}
                            onFocus={() => {
                                setFilteredProviderOptions(providerOptions);
                                if (!groupName && !hasShownGroupValidation) {
                                    setModalMessage("Please select a group before selecting a physician.")
                                    setShowValidationModal(true);
                                    setHasShownGroupValidation(true);
                                } else {
                                    setShowProviderDropdown(true);
                                }
                            }}
                        />

                        {showProviderDropdown && filteredProviderOptions.length > 0 && (
                            <ul className="dropdown-list">
                            {filteredProviderOptions.map((opt, idx) => (
                                <li
                                key={idx}
                                onMouseDown={() => {
                                    setPhysicianName(opt.ProName);
                                    setShowProviderDropdown(false);
                                }}
                                >
                                {opt.ProName}
                                </li>
                            ))}
                            </ul>
                        )}
                    </div>
                    )}
                    {formErrors.physicianName && <div className="form-field-error-message">{formErrors.physicianName}</div>}
                </div>
            </div>
        </div>

        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-md-4">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                    {isAgency ? t("Agencytelname"): isProvider ? t("Providertelname") : t("Physiciantelname")}
                    </label>
                </div>
                <div class="col-md-8">
                    <input type="text" 
                        className="form-control win-form-control mobile-view"
                        value={physicianTel}
                        onChange={(e) => {
                            // Only allow up to 16 digits
                            const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 16);
                            setPhysicianTel(value);
                            setFormErrors((prevErrors) => ({ ...prevErrors, physicianTel: "" }));
                        }}
                        onBlur={() => {
                            // Show error if not phone is invalid
                            if (physicianTel && !/^\d{10,}$/.test(physicianTel)) {
                                setFormErrors((prevErrors) => ({ ...prevErrors, physicianTel: t("Please enter a valid phone number") }));
                            }
                        }}
                        maxLength="16"
                        autoComplete="off"
                    />                    
                    {formErrors.physicianTel && <div className="form-field-error-message">{formErrors.physicianTel}</div>}
                </div>
            </div>
        </div>

        <div class="mt-2 winpay-table-wrapper">

            {/* Same below table in Mobile View */}
            <div className="d-none d-md-block">
                <table className="table winpay-table">
                    <thead className="winpay-table-header">
                        <tr className="winpay-table-header">
                            <th width="200" className="ps-3">
                            {t("datetbl")}
                            </th>
                            <th className="ps-3">{t("descriptiontbl")}</th>
                            <th width="240" className="ps-3">{t("currencytbl")}</th>
                            <th width="200" className="ps-3">{t("amounttbl")}</th>
                            <th width="140" className="text-center">{t("actionstbl")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRows.map((row, index) => (
                            <tr key={index} className="winpay-table-row">
                            <td>
                                <DatePicker
                                selected={row.date ? new Date(row.date) : null}
                                onChange={(date) => handleInputChange(index, "date", date)}
                                dateFormat="MM/dd/yyyy"
                                className="custom-datepicker form-control win-form-control w-100-percent calendar-control"
                                placeholderText="MM/DD/YYYY"
                                showYearDropdown
                                scrollableYearDropdown
                                maxDate={new Date()}
                                onKeyDown={(e) => e.preventDefault()} // Prevent manual input
                                disabled={!row.isEditable}
                                />
                            </td>
                            <td>
                                <input
                                type="text"
                                value={row.description}
                                onChange={(e) => handleInputChange(index, "description", e.target.value)}
                                className="form-control win-form-control w-100-percent"
                                disabled={!row.isEditable}
                                />
                            </td>
                            <td className="custom-dropdown-width-controll">
                                <CustomDropdown
                                    options={currencyOptions}
                                    selectedOption={row.currency}
                                    onChange={(option) => handleInputChange(index, "currency", option)}
                                    searchable={true}
                                    placeholder={t("currencyplaceholder")}
                                    disabled={!row.isEditable || row.isCurrencyDisabled}
                                    isLoading={isCurrenciesLoading}
                                    noOptionsMessage={NO_CURRENCIES_MESSAGE}
                                />
                            </td>
                            <td>
                                <input
                                type="text"
                                value={
                                    row.isEditable
                                    ? row.amount // Raw input during editing
                                    : formatAmountForDisplay(row.amount) // US format when not editable
                                }
                                onChange={(e) => handleInputChange(index, "amount", e.target.value)}
                                onKeyDown={handleKeyDown}
                                className="form-control win-form-control w-100-percent"
                                min={0}
                                disabled={!row.isEditable}
                                inputMode="decimal"
                                />
                            </td>
                            <td align="center">
                                <button
                                className="win-btn-secondary-winpay-gird"
                                onClick={() => handleDeleteRow(index)} // Remove the row
                                >
                                {t('removebtn')}
                                </button>
                            </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="winpay-table-row">
                            <td colSpan="3">{t('totalrequestedamount')}</td>
                            <td className="ps-4">{Number(totalAmount).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                                })}
                            </td>
                            <td align="center">
                            <button className="win-btn-primary-winpay-gird" onClick={handleAddRow}>
                            {t('addrow')}
                            </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        

            {/* Same above table in Mobile View */}
            <div className="d-md-none"> 
                {tableRows.map((row, index) => (
                <div className="mobile-row mb-3 p-3 border rounded" key={index}>
                    <div><strong>{t("datetbl")}:</strong>
                    <DatePicker
                        selected={row.date ? new Date(row.date) : null}
                        onChange={(date) => handleInputChange(index, "date", date)}
                        dateFormat="MM/dd/yyyy"
                        className="form-control win-form-control mobile-view"
                        placeholderText="MM/DD/YYYY"
                        showYearDropdown
                        scrollableYearDropdown
                        maxDate={new Date()}
                        onKeyDown={(e) => e.preventDefault()}
                        disabled={!row.isEditable}
                    />
                    </div>
                    <div className="mt-2"><strong>{t("descriptiontbl")}:</strong>
                    <input
                        type="text"
                        value={row.description}
                        onChange={(e) => handleInputChange(index, "description", e.target.value)}
                        className="form-control win-form-control mobile-view"
                        disabled={!row.isEditable}
                    />
                    </div>
                    <div className="mt-2"><strong>{t("currencytbl")}:</strong>
                    <CustomDropdown
                        options={currencyOptions}
                        selectedOption={row.currency}
                        onChange={(option) => handleInputChange(index, "currency", option)}
                        searchable
                        placeholder={t("currencyplaceholder")}
                        disabled={!row.isEditable || row.isCurrencyDisabled}
                        isLoading={isCurrenciesLoading}
                        noOptionsMessage={NO_CURRENCIES_MESSAGE}
                    />
                    </div>
                    <div className="mt-2"><strong>{t("amounttbl")}:</strong>
                    <input
                        type="text"
                        value={
                        row.isEditable
                            ? row.amount
                            : formatAmountForDisplay(row.amount)
                        }
                        onChange={(e) => handleInputChange(index, "amount", e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="form-control win-form-control mobile-view"
                        min={0}
                        disabled={!row.isEditable}
                        inputMode="decimal"
                    />
                    </div>
                    <div className="mt-3 text-center">
                    <button
                        className="win-btn-secondary highmark-option-no-border mobile-view"
                        onClick={() => handleDeleteRow(index)}
                    >
                        {t('removebtn')}
                    </button>
                    </div>
                </div>
                ))}
                <div className="text-end mt-3">
                <div><strong>{t('totalrequestedamount')}:</strong> {Number(totalAmount).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</div>
                <button className="win-btn-primary mobile-view mt-3" onClick={handleAddRow}>
                    {t('addrow')}
                </button>
                </div>
            </div>
        </div>
        
        {formErrors.table && <div className="form-field-error-message">{formErrors.table}</div>}
        <div className="col-12 d-flex mt-1 mb-5">
            <div className="me-2">
            <input
          type="checkbox"
          className="form-check-input radio-btn win-form-check-input mobile-view"
          checked={checkboxChecked}
          onChange={() => {
            setCheckboxChecked(!checkboxChecked);
            setFormErrors((prevErrors) => ({ ...prevErrors, checkbox: "" }));
          }}
         
        />
            </div>
        <div className="note-black-14 ms-3">
            <Trans
                i18nKey="termsandcondition"
                values={{ companyName }}
                components={{ strong: <strong /> }}
            />
        </div>
        </div>
        {formErrors.checkbox && <div className="form-field-error-message">{formErrors.checkbox}</div>}
        <div className="col-12 text-center mb-4">
        <button className="win-btn-primary mobile-view" onClick={handleSubmit}>{t('senddocumentsbtn')}</button>
        </div>
        <div className="col-12 text-center mb-4">&nbsp;</div>
        <ErrorModal  show={showDeleteModal}
        message={modalMessage}
        onClose={() => setShowDeleteModal(false)}
        onOkay={confirmDeleteRow}
        isCancellationSelected={true}  />
    <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose} closeButton={true} />
    <ErrorModal show={showValidationModal} message={modalMessage} onClose={() => setShowValidationModal(false)} closeButton={true} />
    </>
)
}
export default WINPayReaimbursement;
